/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './sample-container-test-sample.reducer';

export const SampleContainerTestSampleDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const sampleContainerTestSampleEntity = useAppSelector(state => state.sampleContainerTestSample.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sampleContainerTestSampleDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.sampleContainerTestSample.detail.title">SampleContainerTestSample</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.sampleContainerTestSample.id">Id</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTestSampleEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.sampleContainerTestSample.active">Active</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTestSampleEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.sampleContainerTestSample.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTestSampleEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.sampleContainerTestSample.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTestSampleEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.sampleContainerTestSample.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTestSampleEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.sampleContainerTestSample.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTestSampleEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.sampleContainerTestSample.container">Container</Translate>
          </dt>
          <dd>{sampleContainerTestSampleEntity.container ? sampleContainerTestSampleEntity.container.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.sampleContainerTestSample.testItem">Test Item</Translate>
          </dt>
          <dd>{sampleContainerTestSampleEntity.testItem ? sampleContainerTestSampleEntity.testItem.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/sample-container-test-sample" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sample-container-test-sample/${sampleContainerTestSampleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SampleContainerTestSampleDetail;
